export default function Contact() {
  return (
    <main className="contact-page">
      <section className="text-area contact-card">
        <h1>Contact</h1>

        <p>
          Reach out for game testing, feedback, collaboration,</p>
          <p>project updates, or questions about ColdFlare Studios.
        </p>

        <h2>Contact Jason / ColdFlare Studios</h2>

        <div className="social-links">
          <a
            href="mailto:coldflare.studios@gmail.com"
            className="contact-link"
          >
            coldflare.studios@gmail.com
          </a>

          <a
            href="https://coldflarestudios.itch.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            itch.io
          </a>

          <a
            href="https://www.youtube.com/channel/UCqsWc_T_mwnA-i1E_YHa8Cg"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            YouTube
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=61578056426456"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            Facebook
          </a>
        </div>
      </section>
    </main>
  );
}